import { ImagePlaceholderType } from '../../../../subcomponents/image/types/placeholder-type';
import { EventImageMediaType } from '../types/media-type';
export const getEventImagePlaceholderType = (mediaType) => {
    switch (mediaType) {
        case EventImageMediaType.Gallery:
            return ImagePlaceholderType.EventGallery;
        case EventImageMediaType.Poster:
        default:
            return ImagePlaceholderType.EventPoster;
    }
};
